export default "__VITE_ASSET__vgGXkg5$__"